import { SVGProps } from 'react';

const SvgChart = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M1.293 11.293A1 1 0 0 1 2 11h4a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-9a1 1 0 0 1 .293-.707ZM3 13v7h2v-7H3ZM9.293 2.293A1 1 0 0 1 10 2h4a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V3a1 1 0 0 1 .293-.707ZM11 4v16h2V4h-2ZM17.293 6.293A1 1 0 0 1 18 6h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V7a1 1 0 0 1 .293-.707ZM19 8v12h2V8h-2Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgChart;
